define('directives/jquery/sortable',[
	"application",
	"jquery",
	"jqueryui"
], function (app, $) {

	return app.directives.directive("sortable", function () {

		return {
			restrict: "A",
			link: function ($scope, $element, attrs) {
				var receiveHandler = null;
				$scope.$watch(attrs.sortableReceive, function (value) { receiveHandler = value; });

				var receive = function (element, ui) {
					var scope = angular.element(ui.item).scope();
					var prevScope = angular.element(ui.item.prev()).scope();

					if (receiveHandler) {
						$scope.$apply(function () {
							$(ui.item[0]).remove();

							receiveHandler(scope, prevScope);
						});
					}
				};

				var options = {
					receive: receive
				};
				var additionalOptions = attrs.sortable ? $scope.$eval(attrs.sortable) : {};
				angular.extend(options, additionalOptions);

				$element.sortable(options);
			}
		};

	});

});
